import React, { useContext } from 'react';

import { Image } from '$partials/media';
import { ArrowRightIcon } from '$partials/icon';
import { StaffModal } from '$partials/modals';
import { ModalContext } from '$contexts/modal.jsx';

/* ========================================================================= */
/* Component(s) */
/* ========================================================================= */

/**
 * @type {import('$types/components/partials/listings').StaffItem}
 */
const StaffPage = ({
    as: ComponentTag = 'article',
    className,
    id,
    profileImage,
    name,
    email,
    jobTitle,
    tel,
    altTel,
    biography,
}) => {
    const { handleModal } = useContext(ModalContext);

    return (
        <ComponentTag className={`flex flex-col ${className ? className : ''}`}>
            <div className='bg-white p5 pb6 md-p6 md-pb8 flex-1'>
                {/* Profile image */}
                {profileImage && (
                    <div
                        className='flex flex-col bg-white grey team-fixed-height'>
                        <div
                            className='team-item-height'
                            style={{
                                width: `${(profileImage?.width / profileImage?.height)}em` ,
                                maxWidth: '100%'
                            }}>
                            <Image {...profileImage}/>
                        </div>
                    </div>
                )}
                <div className='mt5 mb6 md-my5 black'>
                    {/* Job title */}
                    {jobTitle && (
                        <p className='type-style-5'>
                            {jobTitle}
                        </p>
                    )}
                    {/* Name */}
                    <h3 className='type-style-3'>
                        {name}
                    </h3>
                </div>
                {/* CTA */}
                <button
                    className='form-field-reset black inline-flex items-center type-style-5 cursor-pointer'
                    onClick={() => handleModal(
                        <StaffModal {...{
                            id,
                            profileImage,
                            name,
                            email,
                            jobTitle,
                            tel,
                            altTel,
                            biography}}/>
                    )}
                    type='button'>
                    <span>
                        Contact
                    </span>
                    <span
                        aria-hidden={true}
                        className='font-0 line-height-0 ml5 mtn1'>
                        <ArrowRightIcon/>
                    </span>
                </button>
            </div>
        </ComponentTag>
    );
};

/* ========================================================================= */
/* Typing and exports */
/* ========================================================================= */

export default StaffPage;
